import FlashLib from "flashlib";

export default class BaseCheckBox extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this._actions = {};
        this._enabled = false;
        this._checked = false;

        this.init();
        this.addListeners();

        this.enabled = false;
    }

    init() {
        this.interactive = true;
        this.buttonMode = true;
    }

    addListeners() {
        this.on('pointertap', this.onEvent, this);
    }

    onEvent($data) {
        switch ($data.type) {
            case 'pointertap':
                this.onClick();
                break;
        }
    }


    onClick() {
        this.checked = !this.checked;
        let actionData = this.actions[this.checked ? 'checked' : 'unchecked'];
        if (actionData) {
            if (actionData.callback) {
                actionData.callback.call(actionData.context, actionData.params);
            }
        }
    }

    get actions() {
        return this._actions;
    }

    set actions(value) {
        this._actions = value;
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
        if (value) {
            this.interactive = true;
            this.buttonMode = true;
        } else {
            this.interactive = false;
            this.buttonMode = false;
        }
    }

    get checked() {
        return this._checked;
    }

    set checked(value) {
        this._checked = value;
        this.goToFrame(this.checked ? 2 : 1);
    }
}
